import React, { Component } from 'react'
import Slider from "react-slick";
import play from '../assets/episodeplay.png'
import larrow from '../assets/larrow.png'
import bullet from '../assets/bullet.png'
import rarrow from '../assets/rarrow.png'
import back from "../assets/backarrow.png"
import Header from "../header/header"
import "./episodes.css"
import Footer from '../footer/newfooter';
import { Link } from 'react-router-dom';
import AllTopics from './alltopics';
import MailChimp from './mailchimp';
import Axios from 'axios';
import { BASE } from '../api/api';
import HtmlParser from 'react-html-parser';


class Episodes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            topic: null,
            viewall: window.innerWidth > 575 ? true : false
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.loadDetails()
    }
    loadDetails() {
        window.scrollTo(0, 0)
        Axios.get(`${BASE}jsonapi/taxonomy_term/topic/${this.props.match.params.id}`)
            .then(data => {
                this.setState({
                    topic: data.data.data.attributes.name,
                    topicDetails: data.data.data
                })
            })
        Axios.get(`${BASE}jsonapi/node/podcast?include=field_topic,field_episode_thumbnail&filter[topic][condition][path]=field_topic.id&filter[topic][condition][value]=${this.props.match.params.id}&sort=-field_number_of_episode`)
            .then(data => {
                console.log("episodes in page", data.data.data)
                this.setState({
                    count: data.data.data.length,
                    episodes: data.data.data,
                    episodeInclude: data.data.included
                })
            })
    }
    componentDidUpdate(nextProps) {
        if (this.props.match.params.id !== nextProps.match.params.id) {
            this.setState({
                topic: null,
                episodes: null,
                count: null
            })
            this.loadDetails()
        }
    }
    render() {
        const latest = [
            { "id": "l-1", "img": "/cluster/c1.png", "title": "Importance of Islamic Finance Education", "topic": "Emad El-Din Shahin", "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin scelerisque risus, tortor, ", "min": "60min" },
            { "id": "l-1", "img": "/cluster/c1.png", "title": "Importance of Islamic Finance Education", "topic": "Emad El-Din Shahin", "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin scelerisque risus, tortor, ", "min": "60min" },
            { "id": "l-1", "img": "/cluster/c1.png", "title": "يمالسإلا ليومتلاو داصتقإلل رشاعلا يملاعلا رمتؤملا ثاحبأ نم تاراتخم", "topic": "داصتقإلل رشاعلا", "description": "ةحودلا يف ، 2015 سرام يف دقع يذلا ،يمالسإلا ليومتلاو داصتقالل رشاعلا يلودلا رمتؤملا ىلإ تمدق ةيبرعلا ةغللاب ةراتخم ًاقاروأ مّدقت يتلا بتكلا ةلسلس نم سماخلا دلجملا وه باتكلا اذه", "min": "60min" },
            { "id": "l-1", "img": "/cluster/c1.png", "title": "Importance of Islamic Finance Education", "topic": "Emad El-Din Shahin", "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin scelerisque risus, tortor, ", "min": "60min" },
            { "id": "l-1", "img": "/cluster/c1.png", "title": "Importance of Islamic Finance Education", "topic": "Emad El-Din Shahin", "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin scelerisque risus, tortor, ", "min": "60min" },
            { "id": "l-1", "img": "/cluster/c1.png", "title": "يمالسإلا ليومتلاو داصتقإلل رشاعلا يملاعلا رمتؤملا ثاحبأ نم تاراتخم", "topic": "داصتقإلل رشاعلا", "description": "ةحودلا يف ، 2015 سرام يف دقع يذلا ،يمالسإلا ليومتلاو داصتقالل رشاعلا يلودلا رمتؤملا ىلإ تمدق ةيبرعلا ةغللاب ةراتخم ًاقاروأ مّدقت يتلا بتكلا ةلسلس نم سماخلا دلجملا وه باتكلا اذه", "min": "60min" },
        ]
        return (
            <div className='episodes podcast'>
                <Header />
                <div className='episode-banner'>
                    <div className='container'>
                        <div className='back'>
                            <Link to="/podcast"><span><img src={back} /></span>&nbsp; Back</Link>
                        </div>
                        <div className='details'>
                            {this.state.topic ? <div className='flex-row episode-head'>
                                <div className='topic-head'>{this.state.topic ? this.state.topic : ""}</div>
                                <div className='total-episode'>{this.state.count} Episodes</div>
                            </div> : ""}
                            <p className='topic-description'>
                                {this.state.topicDetails ? this.state.topicDetails.attributes.description ? HtmlParser(this.state.topicDetails.attributes.description.value) : "" : ''}
                            </p>
                        </div>
                    </div>
                </div>

                <div className='all-episodes'>
                    <div className='container'>
                        <div className='all-episode-head'>All Episodes</div>
                        <div className='flex-wrap latest'>
                            {this.state.episodes ? this.state.episodes.map((item, ind) => {
                                let aa = item.attributes.title.toString()
                                let link = aa.replace(/ /g, '-')
                                let links = link.replace(/\?/g, "")
                                let lang = item.attributes.field_podcast_language ? item.attributes.field_podcast_language == "arabic" ? "arabic" : "english" : "english"
                                let episode = item.attributes.field_number_of_episode < 10 ? `0${item.attributes.field_number_of_episode}` : item.attributes.field_number_of_episode
                                // let lang = item.relationships.field_language_of_podcast.data ? this.state.episodeInclude.filter(x => x.id == item.relationships.field_language_of_podcast.data.id)[0].attributes.name : ""
                                let thumbnail = item.relationships.field_episode_thumbnail.data ? this.state.episodeInclude.filter(x => x.id == item.relationships.field_episode_thumbnail.data.id).length ? this.state.episodeInclude.filter(x => x.id == item.relationships.field_episode_thumbnail.data.id)[0].attributes.uri.url : "" : ""
                                if (this.state.viewall)
                                    return (
                                        <div className={lang ? lang == "arabic" ? "right-align w-32" : "left w-32" : "left w-32"} style={{ marginRight: (ind + 1) % 3 == 0 ? "0" : "2%", textAlign: lang ? lang == "arabic" ? "right" : "left" : "left" }} >
                                            <div className='latest-image-container'>
                                                <img className='latest-img' src={thumbnail ? `${BASE}${thumbnail}` : "/cluster/c1.png"} />
                                                <div className='ep-count'>{item.attributes.field_number_of_episode ? lang == "arabic" ? `EP ${episode} A` : `EP ${episode} E` : ""}</div>

                                            </div>
                                            {/* <p className='topic'><span><img src={bullet} />&nbsp;</span>{item.attributes.field_name_of_the_speaker ? item.attributes.field_name_of_the_speaker : ''}</p> */}
                                            <Link to={`/podcast/${links}?id=${item.id}`} onClick={() => window.scrollTo(0, 0)} className='title'>{item.attributes.title ? item.attributes.title : ""}</Link>
                                            <p className='description'>{item.attributes.field_short_description ? HtmlParser(item.attributes.field_short_description.value) : ""}</p>
                                            <div className='flex-row play-div'>
                                                <Link to={`/podcast/${links}?id=${item.id}`} className='play-button'>
                                                    <span><img src={play} /></span>  Play this episode
                                                </Link>
                                                <div className="mins">{item.attributes.field__podcast_length ? item.attributes.field__podcast_length + " min" : ""}</div>
                                            </div>
                                        </div>
                                    )
                                else
                                    if (ind < 3)
                                        return (
                                            <div className={lang ? lang == "arabic" ? "right-align w-32" : "left w-32" : "left w-32"} style={{ marginRight: (ind + 1) % 3 == 0 ? "0" : "2%", textAlign: lang ? lang == "arabic" ? "right" : "left" : "left" }} >
                                                <div className='latest-image-container'>
                                                    <img className='latest-img' src={thumbnail ? `${BASE}${thumbnail}` : "/cluster/c1.png"} />
                                                    <div className='ep-count'>{item.attributes.field_number_of_episode ? lang == "arabic" ? `EP ${episode} A` : `EP ${episode} E` : ""}</div>
                                                </div>
                                                {/* <p className='topic'>{item.attributes.field_name_of_the_speaker ? item.attributes.field_name_of_the_speaker : ''}</p> */}
                                                <Link to={`/podcast/${links}?id=${item.id}`} onClick={() => window.scrollTo(0, 0)} className='title'>{item.attributes.title ? item.attributes.title : ""}</Link>
                                                <p className='description'>{item.attributes.field_short_description ? HtmlParser(item.attributes.field_short_description.value) : ""}</p>
                                                <div className='flex-row play-div'>
                                                    <Link to={`/podcast/${links}?id=${item.id}`} className='play-button'>
                                                        <span><img src={play} /></span>  Play this episode
                                                    </Link>
                                                    <div className="mins">{item.attributes.field__podcast_length ? item.attributes.field__podcast_length + " min" : ""}</div>
                                                </div>
                                            </div>
                                        )
                            }) : ""}
                            {this.state.topicDetails && this.state.episodes ? this.state.episodes.length > 3 && !this.state.viewall ? <div className="podcast-pagination" onClick={() => { this.setState({ viewall: true }) }}>
                                View All
                            </div> : "" : ""}
                        </div>
                    </div>
                </div>
                <AllTopics />
                <MailChimp />
                <Footer />
            </div>
        )
    }

} export default Episodes;